import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SolicitacaoContatoPage } from './solicitacao-contato';
import { SolicitacaoContatoPageProvider } from './solicitacao-contato.provider';
import { UserProvider } from '../../providers/user/user';

@NgModule({
  declarations: [
    SolicitacaoContatoPage,
  ],
  imports: [
    IonicPageModule.forChild(SolicitacaoContatoPage),
  ],
  providers: [
    SolicitacaoContatoPageProvider,
    UserProvider
  ]
})
export class SolicitacaoContatoPageModule { }



// WEBPACK FOOTER //
// ./src/pages/solicitacao-contato/solicitacao-contato.module.ts